// SVG Icon wrapper — usa paths de @mdi/js
export default function BaseIcon({ path, size = 16, w = "w-5", className = "" }) {
  const px = typeof size === "number" ? size : parseInt(size, 10);
  return (
    <svg
      viewBox="0 0 24 24"
      width={px}
      height={px}
      className={[w, "inline-block flex-none", className].filter(Boolean).join(" ")}
      aria-hidden="true"
    >
      <path fill="currentColor" d={path} />
    </svg>
  );
}
